import PropTypes from 'prop-types';

export const ButtonsForm = ({ userType, rebateState, idEstadoRebate, onChangeState, onSubmit, rebate, onDelete }) => {
    if ((userType.isSellerAdmin && rebateState.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory)) {
        return (
            <div className="rebate-form__actions">
                <button
                    onClick={onChangeState}
                    name="aprove"
                    className="btn btn-sm background-rojo-megatone waves-light"
                >
                    Aprobar
                </button>
                <button
                    onClick={onChangeState}
                    name="decline"
                    className="btn btn-sm btn-grey waves-light">
                    Rechazar
                </button>
                <button
                    onClick={onSubmit}
                    hidden={(userType.isCategory && rebate.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebate.idEstadoRebate === idEstadoRebate.aprobadoPorSeller)}
                    type="submit"
                    name="update"
                    className="btn btn-sm btn-light waves-light"
                >
                    Modificar
                </button>
            </div>
        )
    } else {
        return (
            <div className="rebate-form__actions">
                <button
                    type="submit"
                    onClick={onDelete}
                    className="btn btn-sm btn-grey waves-light"
                >
                    Eliminar
                </button>
                <button
                    type="submit"
                    name="update"
                    onClick={onSubmit}
                    disabled={rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorSeller}
                    className="btn btn-sm btn-light waves-light"
                >
                    Modificar
                </button>
            </div>
        )
    }
}
ButtonsForm.propTypes = {
    userType: PropTypes.shape({
        isCategory: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
    }),
    rebateState: PropTypes.shape({
        idEstadoRebate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    idEstadoRebate: PropTypes.shape({
        aprobado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        aprobadoPorSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        aprobadoPorCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    onChangeState: PropTypes.func,
    onSubmit: PropTypes.func,
    onDelete: PropTypes.func,
    rebate: PropTypes.shape({
        idEstadoRebate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
}